import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { initialETAInfo } from '../initialState'

const etaSlice = createSlice({
  name: 'etaInfo',
  initialState: initialETAInfo,
  reducers: {
    updateETA: (state: any, action: PayloadAction<any>) => {
      return action.payload
    },
  },
})

export const etaAction = etaSlice.actions
export default etaSlice
